import React from 'react';
import CurvedCutoutMedia from './CurvedCutoutMedia';
import './OnPropertyArrivePortal.css';
import arrivePortalBgImageAvif from 'url:../../assets-optimized/redesign/solutions/on-property/arrive-portal.avif';
import arrivePortalBgImageWebp from 'url:../../assets-optimized/redesign/solutions/on-property/arrive-portal.webp';
import arrivePortalBgImage from 'url:../../assets-optimized/redesign/solutions/on-property/arrive-portal.jpg';

const ArrowDownIcon = () => (
  <svg viewBox='0 0 24 24' fill='none' aria-hidden='true'>
    <path
      d='M12 4V20M12 20L6 14M12 20L18 14'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const OnPropertyArrivePortal = () => {
  return (
    <section className='op-arriveportal-section' aria-label='On-property arrive portal environment'>
      <div className='op-arriveportal-shell'>
        <CurvedCutoutMedia
          className='op-arriveportal-media'
          imageSrc={arrivePortalBgImage}
          imageAvif={arrivePortalBgImageAvif}
          imageWebp={arrivePortalBgImageWebp}
          imageAlt='Table with laptop and coffee'
        />

        <div className='op-arriveportal-overlay'>
          <div className='op-arriveportal-title-layer'>
            <h2 className='op-arriveportal-large-title'>ARRIVE PORTAL</h2>
          </div>

          <div className='op-arriveportal-card'>
            <h3 className='op-arriveportal-card-title'>THE FIRST CONNECTION POINT ON PROPERTY.</h3>
            <p className='op-arriveportal-copy'>
              Before the trip continues, every guest passes through. This make it one of the most
              consistent and unavoidable touchpoints of the stay.
            </p>
          </div>
        </div>

        <button
          className='op-arriveportal-arrow'
          onClick={() => {
            const nextSection = document.querySelector(
              '.op-arriveportal-section'
            ).nextElementSibling;
            if (nextSection) {
              const yOffset = -60;
              const elementPosition = nextSection.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.scrollY + yOffset;
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
              });
            }
          }}
          aria-label='Scroll to next section'
          style={{ cursor: 'pointer', background: 'transparent', border: 'none', padding: 0 }}
        >
          <ArrowDownIcon />
        </button>
      </div>
    </section>
  );
};

export default OnPropertyArrivePortal;
